<div class="preview-wrapper" (click)="open = !open">
	<bp-plus-minus-btn [showMinus]="open"></bp-plus-minus-btn>
	<ng-content select=".preview"></ng-content>
</div>

<div *ngIf="open" @slide class="more-details-wrapper">
	<ng-content select=".more-details"></ng-content>
</div>
